/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Bertemu Orang Baru, Chat, Bersosial",
      "Salah nombor telefon",
      "Get the app",
      "Teruskan dengan Apple",
      "Teruskan dengan Facebook",
      "Teruskan dengan Google",
      "Log masuk",
      "Daftar",
      "Untuk meneruskan, sila masukkan aksara yang kelihatan ke medan input.",
      "Teruskan",
      "Masukkan aksara",
      "Semakan sekuriti",
      "Muat semula",
      "Cipta kata laluan baharu yang anda mudah ingat:",
      "Kemaskini",
      "Sahkan kata laluan",
      "Kata laluan mesti sekurang-kurangnya {{num}} [[characters:num]]",
      "Kata laluan",
      "Cipta kata laluan baharu",
      "Badoo - The Blog",
      "Kerjaya",
      "Chat",
      "Bandar",
      "Urus kuki",
      "Hakcipta © 2006 – kini. Bumble. Semua hak terpelihara.",
      "Apple dan logo Apple ialah tanda dagangan Apple Inc.{{__EOL__}}Google Play ialah tanda dagangan Google LLC.",
      "Muat turun",
      "Facebook",
      "Ikuti kami",
      "Pusat Bantuan",
      "Instagram",
      "Bahasa",
      "LinkedIn",
      "Gambaran Keseluruhan",
      "Badoo adalah sebahagian dari Bumble Inc.",
      "Polisi Privasi",
      "Pusat Keselamatan",
      "Peta laman",
      "Kenyataan Akta Perhambaan Moden",
      "Terma dan Syarat",
      "Twitter",
      "Masukkan e-mel atau nombor telefon bimbit anda dan kami akan menghantar arahan untuk mencipta kata laluan baharu.",
      "Dapatkan kata laluan baharu",
      "Masukkan e-mel atau nombor telefon anda",
      "Terlupa kata laluan",
      "Gambar adalah contoh sahaja",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Tak perlu tunggu ada sepadan.{{__EOL__}}{{__EOL__}}Terus chat dan berkenalan. Pastikan anda betul-betul mengenali satu sama lain.",
      "Bersedai untuk chat sekarang?",
      "Dengan mendaftar, anda bersetuju dengan <a class=\"link\" href=\"{{terms_url}}\">Terma dan Syarat</a> kami. <br/>Ketahui bagaimana kami menggunakan data anda dalam <a class=\"link\" href=\"{{privacy_url}}\">Polisi Privasi</a> kami.",
      "Membantu diri sebenar anda menonjol,<br />untuk dating mengikut citarasa anda.",
      "Jom dating dengan penuh keyakinan.",
      "Atau",
      "Sudah ada akaun?",
      "Daftar dengan e-mel atau nombor telefon",
      "Dating mengikut citarasa anda.{{__EOL__}}Tak perlu minta maaf.",
      "Hanya nak chat? OK.{{__EOL__}}Nak kahwin? Kami suka sekali.{{__EOL__}}{{__EOL__}}Dan jika anda ubah fikiran, bukan masalah, anda boleh.",
      "Nak dating",
      "Mencari jodoh",
      "Boleh chat",
      "Bertemu dengan orang yang mahu benda yang sama.",
      "{{name}}, {{age}}",
      "Keselamatan anda adalah keutamaan kami.",
      "Pusat Keselamatan kami adalah hab pengetahuan yang mengandungi semua sokongan yang anda perlu untuk membantu anda dating dengan penuh keyakinan.",
      "Lawati Pusat Keselamatan kami",
      "Keselamatan dahulu, <br/>ke-dua dan selalu.",
      "Dari detik pertama, saya tahu dia adalah untuk saya...",
      "Mula-mula, I tak cari apa-apa yang serius…",
      "Nasihat untuk berjaya di Badoo App, tunjuk diri sebenar anda...",
      "Kisah Kejayaan Badoo",
      "Lihat lagi kisah kejayaan",
      "{{num}}__CUT__Pernilaian",
      "Apple App Store",
      "Percayai kami. Kami sudah membantu berjuta-juta (dan jutaan lagi) member menemui pasangan mereka sejak 2006.",
      "{{num}}J+__CUT__Muat turun",
      "{{num}}J+",
      "Google Play Store",
      "Kami tahu apa yang kami sedang lakukan.",
      "Log masuk dengan e-mel atau nombor telefon",
      "Masukkan kata laluan anda",
      "Lupa kata laluan?",
      "Daftar",
      "Tak ada akaun?",
      "Log masuk",
      "Daftar"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "aksara"
            ],
            "singular": [
                  "aksara"
            ]
      },
      "day": {
            "plural": [
                  "hari"
            ],
            "singular": [
                  "hari"
            ]
      },
      "hour": {
            "plural": [
                  "jam"
            ],
            "singular": [
                  "jam"
            ]
      },
      "minute": {
            "plural": [
                  "minit"
            ],
            "singular": [
                  "minit"
            ]
      },
      "month": {
            "plural": [
                  "bulan"
            ],
            "singular": [
                  "bulan"
            ]
      },
      "second": {
            "plural": [
                  "saat"
            ],
            "singular": [
                  "saat"
            ]
      },
      "year": {
            "plural": [
                  "tahun"
            ],
            "singular": [
                  "tahun"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
